export const NumberedListIndex = (props: { num: number }) => {
  return <div className="numbered-list-index__container">{props.num}</div>;
};
